module.exports = __webpack_public_path__ + "img/add-package.34ec1ab9.svg";